// extracted by mini-css-extract-plugin
export default {"pinInput":"pin-input__pin-input__iS0il"};